// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DynProperty } from "../../Commons/DynProperty.ts";
import { Resources } from "../../Commons/properties/Resources.ts";
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.ts";
import { QuickTableColumnType, QuickTableEditingInfo } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.ts";

export let NewsItem = function (news, isViewed)
{
    BaseItem.call(this);

    this.Disabled = isViewed   // просмотрена ли новость

    if (news)
    {
        this.news = news;
        if (news.contentIsLink)              // есть ссылка в TEXT[115] то в качестве контента отображаем кликабельную ссылку.
            this.QuickTableEditingInfoMap[3] = (function ()     // Content column
            {
                return new QuickTableEditingInfo(DynProperty.LINK);
            })();
    }
}
NewsItem.prototype = Object.create(BaseItem.prototype);

NewsItem.prototype.getColumnData = function (column)
{
    let value = this.getColumnValue(column);
    let formattedValue = null;

    switch (column)
    {
        case 0:
            formattedValue = value ? DateTimeUtils.formatDate(value, 'DD.MM.YYYY HH:mm:ss') : ''
            break;

        case 6:
            formattedValue = this.getTextPriority(value)
            break;

        default:
            formattedValue = value ? value.toString() : ''
            break;
    }

    return { Value: value, FormattedValue: formattedValue };
}

NewsItem.prototype.getColumnValue = function (column)
{
    let news = this.news

    if (news === null)
        return null;

    switch (column)
    {
        case 0:
            return news.received;

        case 1:
            return news.source;

        case 2:
            return news.subject;

        case 3:
            return news.content;

        case 4:
            return news.category;

        case 5:
            return news.symbol;

        case 6:
            return news.priority;

        default:
            return null;
    }
}

NewsItem.prototype.getLinkInContent = function ()
{
    let news = this.news

    if (news === null)
        return null;

    return news.content
}

NewsItem.prototype.getNewsID = function ()
{
    return this.news ? this.news.GetID() : null
}

NewsItem.prototype.getRouteID = function ()
{
    return this.news ? this.news.GetRouteID() : null
}

NewsItem.prototype.OnNewsDoubleClicked = function ()
{
    if (this.news)
        this.news.OnNewsDoubleClicked()
}

NewsItem.prototype.getTextPriority = function (value)
{
    if (!value)
        return ""

    if (value == "")
        return Resources.getResource("panel.news.Priority_All");
    else if (value == "1")
        return Resources.getResource("panel.news.Priority_1");
    else if (value == "5")
        return Resources.getResource("panel.news.Priority_5");
    else if (value == "10")
        return Resources.getResource("panel.news.Priority_10");
}

NewsItem.prototype.ChangeViewedState = function (newState)
{
    this.Disabled = newState
}

NewsItem.prototype.ColumnCount = function ()
{
    return NewsItem.columnsParams.length;
}

NewsItem.prototype.GetColumnParams = function (column)
{
    let result = NewsItem.columnsParams[column];
    var isHidden = Resources.isHidden(result.HeaderKey);
    result.Hidden = isHidden;
    result.MenuIndex = this.GetMenuIndex(result.HeaderKey);

    return result;
}

NewsItem.prototype.GetMenuIndex = function (headerKey)
{
    if (NewsItem.ListMenuIndex.Contains(headerKey))
        return NewsItem.ListMenuIndex.indexOf(headerKey);
    else
        return 1000;
}

/// <summary>
/// Здесь хранятся настройки колонок (один экземпляр на класс)
/// </summary>
NewsItem.columnsParams = [
    /*0*/   new ColumnParams("panel.news.received", 75, QuickTableColumnType.COL_DATE_SORT, false, true, false),
    new ColumnParams("panel.news.source", 120, QuickTableColumnType.COL_DEFAULT, false, true, true),
    new ColumnParams("panel.news.subject", 120, QuickTableColumnType.COL_DEFAULT, false, true, false),
    new ColumnParams("panel.news.context", 75, QuickTableColumnType.COL_DEFAULT, false, false, false),
    new ColumnParams("panel.news.category", 75, QuickTableColumnType.COL_DEFAULT, false, false, false),
    /*5*/   new ColumnParams("panel.news.symbol", 75, QuickTableColumnType.COL_DEFAULT, false, false, false),
    new ColumnParams("panel.news.priority", 75, QuickTableColumnType.COL_DEFAULT, false, false, false),
];

NewsItem.ListMenuIndex =
    [
        "panel.news.received",
        "panel.news.source",
        "panel.news.subject",
        "panel.news.context",
        "panel.news.category",
        "panel.news.symbol",
        "panel.news.priority",
    ];